import { useState } from 'react';

import type { PopoverContextValue, SinglePopover } from '../PopoverContext';

const usePopoverContextValues = (): PopoverContextValue => {
  const [openedPopovers, setOpenedPopovers] = useState<SinglePopover[]>([]);

  return { openedPopovers, setOpenedPopovers };
};

export default usePopoverContextValues;
